import { postData, getData, putData, deleteData,patchData } from '../../services/axiosServices'

export const mentorLogin = (email, token) => {
    let url = 'users'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`

    }
    return putData(url, { email }, { headers })
}
export const adminLogin = (email, token) => {
    let url = 'admins'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`

    }
    return putData(url, { email }, { headers })
}
export const createUser = (data) => {
    let url = 'users'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, data, { headers })
}
export const createAdmin = (data, coeId = '') => {
    let url = `admins?ejet_coe_center_id=${coeId || ''}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`

    }
    return postData(url, data, { headers })
}
export const editAdmin = (userId, data) => {
    let url = `admins/update/${userId}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const disableAdmin = (id) => {
    let url = `admins/toggle/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url,{},{ headers })
}
// export const unmapAdmin = (id,data) => {
//     let url = `coeCenterAdmin/${id}`
//     const headers = {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${localStorage.getItem('token')}`
//     }
//     return putData(url,data,{ headers })
// }
export const unmapAdmin = (coeId,adminId) => {
    let url = `coeCenterAdmin/coe/${coeId}/admin/${adminId}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return patchData(url,{},{ headers })
}
export const getAllAdmins = () => {
    let url = 'admins'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllLabAdmins = () => {
    let url = 'admins/coeAdmin'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllReportAdmins = () => {
    let url = 'admins/coeReportAdmin'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllReportViewers = () => {
    let url = 'admins/coeReportViewer'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllMentors = () => {
    let url = 'users/mentor'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllPH = () => {
    let url = 'users/practiceHead'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}

export const updateUser = (id, data) => {
    let url = `users/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const disableUser = (id) => {
    let url = `users/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return deleteData(url, { headers })
}

export const addMentorsCSV = (coeID, formData) => {
    let url = `users/${coeID}/mentors/upload`
    const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, formData, { headers })
}

